import { render, staticRenderFns } from "./AutoHeader.vue?vue&type=template&id=fafe5ed6&scoped=true&"
import script from "./AutoHeader.vue?vue&type=script&lang=js&"
export * from "./AutoHeader.vue?vue&type=script&lang=js&"
import style0 from "./AutoHeader.vue?vue&type=style&index=0&id=fafe5ed6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fafe5ed6",
  null
  
)

export default component.exports